var map = {
	"./black/bofangluxiang.png": "WPT+",
	"./blue/bofangluxiang.png": "+iIl",
	"./white/bofangluxiang.png": "gsBd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bSe6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/bofangluxiang\.png$
// module id = bSe6
// module chunks = 24